var lerp = function (a, b, t) {
    return a + (b - a) * t;
};
export { lerp };
